import individualReportResultApi from "@/api/article/individualReportResultApi";

export default {
  namespaced: true,
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await individualReportResultApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'individualReport.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {resultId}) {
      try {
        await individualReportResultApi.delete(resultId);
        dispatch('NOTIFY_MSG', 'individualReport.notification.delete',
          {root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch(_, {reportId}) {
      try {
        const response = await individualReportResultApi.fetch(reportId);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async syncSortOrders(_, form) {
      try {
        await individualReportResultApi.syncSortOrders(form);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
}
